export interface PageTrackingData {
  content_group: string | null,
  content_type: string | null,
  content_name: string | null,
  content_id: string | null,
  [k: string]: string | null,
}

export const useGaTrackingStore = defineStore('gaTracking', () => {
  const pageTrackingData = reactive<PageTrackingData>({
    content_group: null,
    content_type: null,
    content_name: null,
    content_id: null,
  })

  return { pageTrackingData }
})
